var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import DevicesEventsCardAPI from './devices-events-card-api';
import React, { Component } from 'react';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { eventListener } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import { Card, Text } from '@philips-internal/oswald-ui-components/lib/components';
import { SelectionType } from '@philips-internal/oswald-ui-constants';
import { isFunction } from '@philips-internal/oswald-ui-utils';
import { ReactComponent as PendingIcon } from '../../assets/images/global/time.svg';
import { ReactComponent as ReleasedIcon } from '../../assets/images/global/check.svg';
import './devices-events-card.css';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';
import { generateUUID } from '@philips-internal/oswald-ui-utils';
import { DateFormatterUtil } from '../../utils';
const legends = [
    {
        color: 'signal-green-60',
        icon: React.createElement(ReleasedIcon, null),
        label: MessageService.translate('text.finished'),
        value: MessageService.translate('text.finished')
    },
    {
        color: 'signal-orange-45',
        icon: React.createElement(PendingIcon, null),
        label: MessageService.translate('tws.label-pending'),
        value: MessageService.translate('tws.label-pending')
    }
];
let DevicesEventsCard = class DevicesEventsCard extends Component {
    constructor() {
        super(...arguments);
        this.handleClick = () => {
            const { eventClassificationDescription, eventDate, ieReleased, onClick } = this.props;
            if (isFunction(onClick)) {
                onClick(new ClickEvent({
                    value: {
                        eventClassificationDescription,
                        eventDate,
                        ieReleased,
                    }
                }));
            }
        };
    }
    static { this.propTypes = {
        onClick: eventListener
    }; }
    getStatusIcon() {
        const { ieReleased } = this.props;
        if (ieReleased && ieReleased.toUpperCase() === 'S') {
            return React.createElement(ReleasedIcon, { className: 'c-devices-events-card__color-green' });
        }
        return React.createElement(PendingIcon, { className: 'c-devices-events-card__color-orange' });
    }
    renderStatus() {
        return (React.createElement("div", { className: 'c-devices-events-card__status' }, this.getStatusIcon()));
    }
    renderCard() {
        const { eventClassificationDescription, eventDate } = this.props;
        const formatDateTime = DateFormatterUtil.timeStamp(String(eventDate));
        return (React.createElement("div", { className: 'c-devices-events__wrapper' },
            React.createElement("div", { className: 'c-devices-events-content-item' },
                React.createElement("div", { className: 'c-devices-events-content-icon' }, this.renderStatus()),
                React.createElement("div", { className: 'c-devices-events-content' },
                    React.createElement(Text, { bold: true, className: "c-title-value", value: eventClassificationDescription }),
                    React.createElement("div", { className: 'c-devices-events-content-column' },
                        React.createElement("div", { className: 'c-devices-events-content-p1' },
                            React.createElement(Text, { className: "c-text-value", value: formatDateTime })))))));
    }
    render() {
        const { eventClassificationDescription, eventDate } = this.props;
        return (React.createElement(Card, { className: 'c-devices-events-main', selectionType: SelectionType.SINGLE, superscription: legends, width: 12, onClick: this.handleClick, uuid: generateUUID(), key: `${eventClassificationDescription} + ${eventDate}` }, this.renderCard()));
    }
};
DevicesEventsCard = __decorate([
    AwesomeComponent({ api: DevicesEventsCardAPI, type: ComponentType.DATA_DISPLAY })
], DevicesEventsCard);
export default DevicesEventsCard;
//# sourceMappingURL=devices-events-card.js.map